var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"chart-id":_vm.chartId,"dataset-id-key":_vm.datasetIdKey,"css-classes":_vm.cssClasses,"styles":_vm.styles,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }